import { create } from 'zustand';
import type { NavItemId } from '@shared/config/app';

interface NavigationState {
  activeTab: NavItemId;
  setActiveTab: (tab: NavItemId) => void;
}

export const useAppNavigationStore = create<NavigationState>((set) => ({
  activeTab: 'preview',
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
